import React, { Component } from "react";

class Telegram extends Component {
    render() {
      return (
        <div>
          <a
            id="Telegram"
            href="https://t.me/fortissimo_breakfasy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact us on Telegram!
          </a>
        </div>
        //<div>
          //<a
            //id="Telegram"
            //href="https://t.me/fortissimo_breakfasy"
            //target="_blank"
            //rel="noopener noreferrer"
          //>
            //Organize deliveries or catering on Telegram!
          //</a>
        //</div>
        //<h1 id="Telegram">
          //<div>
            //<a
              //href="https://t.me/joinchat/HZ-7rqoRrOUzNzZl"
              //target="_blank"
              //rel="noopener noreferrer"
            //>**Delivery in SF on Telegram** </a>
            //<a
              //href="https://t.me/joinchat/9BzbonBGc-FhMGE1"
              //target="_blank"
              //rel="noopener noreferrer"
            //>**Delivery in SG on Telegram**</a>
          //</div>
        //</h1>
        //<h1 id="Telegram">
          //<div>
            //<a
              //href="https://t.me/joinchat/HZ-7rqoRrOUzNzZl"
              //target="_blank"
              //rel="noopener noreferrer"
            //>**Yummies in SF on Telegram** </a>
            //<a
              //href="https://t.me/joinchat/9BzbonBGc-FhMGE1"
              //target="_blank"
              //rel="noopener noreferrer"
            //>**Yummies in SG on Telegram**</a>
          //</div>
        //</h1>
        //<div>
          //<a
            //id="Telegram"
            //href="https://t.me/fortissimo_breakfasy"
            //target="_blank"
            //rel="noopener noreferrer"
          //>
            //Contact us for Yummies on Telegram!
          //</a>
        //</div>
      );
    }
  }
  //Message us on Telegram!
  export default Telegram;